import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { DynamicComponentDirective, MenuItemsService, MenuSection } from '@frontend/vanilla/core';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [CommonModule, DynamicComponentDirective],
    selector: 'vn-am-row-layout',
    templateUrl: 'row-layout.html',
})
export class RowLayoutComponent extends AccountMenuItemBase {
    private menuItemsService = inject(MenuItemsService);

    isActive() {
        return this.menuItemsService.isActive(MenuSection.Menu, this.item.name);
    }
}
